import { Mensagem } from './mensagem'

export enum TipoArea {
    SETOR = "SETOR",
    CENTRO_CUSTO = "CENTRO_CUSTO"
}

export interface Area {
    idArea: number,
    codArea: number,
    idAdministradores: number[],
    idMembros: number[],
    nome: string,
    tipo: TipoArea,
    nomeTipo: string,
    hashImagem: string,
    numMensagensNaoLidas?: number
}

export interface AreaComum extends Area {
    mensagens: Mensagem[]
}

export interface ConversaUsaurio {
    idUsuario: number,
    nomeUsuario: string,
    hashImagem: string,
    mensagens: Mensagem[]
}

export interface AreaAdmin extends Area {
    mensagensGerais: Mensagem[],
    conversasUsuarios: ConversaUsaurio[]
}


// WEBPACK FOOTER //
// ./src/models/area.ts